import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/dashboard";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav(next);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    }
    setBusy(false);
  };

  return (
    <main data-testid="login-page" className="min-h-screen bg-[#0D0C0A] pt-32 pb-24 px-6 flex items-center justify-center">
      <div className="w-full max-w-md">
        <p className="label-eyebrow mb-4">Welcome back</p>
        <h1 className="font-display text-4xl sm:text-5xl mb-10">Return to the <span className="italic text-[#D4AF37]">studio</span>.</h1>

        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="label-eyebrow block mb-3">Email</label>
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-[#332D29] focus:border-[#D4AF37] focus:outline-none py-3 text-[#F5F2EB] placeholder:text-[#B3AFA8]/50"
              placeholder="you@studio.com"
            />
          </div>
          <div>
            <label className="label-eyebrow block mb-3">Password</label>
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-[#332D29] focus:border-[#D4AF37] focus:outline-none py-3 text-[#F5F2EB] placeholder:text-[#B3AFA8]/50"
              placeholder="••••••••"
            />
          </div>
          <button type="submit" disabled={busy} data-testid="login-submit" className="btn-gold w-full py-4 rounded-full text-sm mt-4 disabled:opacity-60">
            {busy ? "Opening the door…" : "Sign in"}
          </button>
        </form>

        <p className="text-[#B3AFA8] text-sm mt-10 text-center">
          New to the studio?{" "}
          <Link to="/signup" className="text-[#D4AF37] hover:underline">Join here</Link>.
        </p>
      </div>
    </main>
  );
}
